import {
  GetDocumentTemplateExtendsOptions,
  IDocumentTemplate,
} from '@commenda/types/src/document-generation';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';

interface UseDocumentTemplateResponse {
  data: IDocumentTemplate;
}

export const useDocumentTemplate = (
  documentTemplateId: string | undefined,
  queryParams?: { extends?: GetDocumentTemplateExtendsOptions[] }
) => {
  const query = new URLSearchParams();
  if (queryParams?.extends) {
    queryParams.extends.forEach((ext: GetDocumentTemplateExtendsOptions) =>
      query.append('extends', ext)
    );
  }

  const queryString = query.toString();
  const url = documentTemplateId
    ? `${BASE_URL}/${documentTemplateId}${queryString ? `?${queryString}` : ''}`
    : null;

  const { data, error, isLoading, mutate } =
    useSWR<UseDocumentTemplateResponse>(
      url,
      SWRFetcher({
        method: 'GET',
      })
    );

  return { data, error, isLoading, mutate };
};
